import {Navigate, useLocation, useRoutes} from 'react-router-dom';
// config
import {PATH_AFTER_LOGIN} from 'src/config-global';
//
import {mainRoutes} from './main';

import {authRoutes} from './auth';
import {dashboardRoutes} from './dashboard';
import {registersRoutes} from './registers';
import {employeesRoutes} from './employees';
import {transportsRoutes} from './transports';
import {nomenclaturesRoutes} from './nomenclatures';
import {createBrowserHistory} from 'history';
import {usePermission} from 'src/hooks/use-permission';
import {useSelector} from 'react-redux';
import {docTemplatesRoutes} from './doc-templates';
import {endpointsRoutes} from './endpoints';
import {sellersRoutes} from './sellers';
import {companiesRoutes} from './companies';
import {reportDetailsRoutes} from './report-details';
import {reportsRoutes} from './reports';
import {usePermissions} from 'src/hooks/use-permissions';

// ----------------------------------------------------------------------

const history = createBrowserHistory()

export function RedirectWithParams({to}) {
  const {search} = useLocation();
  const inputParams = new URLSearchParams(search);

  const state = inputParams.get('state');
  const code = inputParams.get('code');

  const targetParams = new URLSearchParams();
  if (state) targetParams.set('state', state);
  if (code) targetParams.set('code', code);

  const finalTo = targetParams.toString() ? `${to}?${targetParams}` : to;

  return <Navigate to={finalTo} replace />;
}
const RedirectWithQuery = ({to}) => {
  const location = useLocation();

  return (
    <Navigate
      to={`${to}${location.search}`}
      replace
    />
  );
};
const router = function Router() {
  const {isApprover, isCreator} = usePermission()
  const {personalAccountSettings} = usePermissions()
  const permissions = useSelector(store => store.user?.permissions)


  const selectedEndpointId = useSelector(store => store.endpoint.selectedEndpoint?.id)
  const endpointPermissions = permissions?.endpoints ? permissions.endpoints[selectedEndpointId] : {}

  const canEditEndpoint = endpointPermissions?.merchant_permissions?.can_edit_endpoint
  const canCreateEndpoint = endpointPermissions?.merchant_permissions?.can_create_endpoint

  const canEditEmployee = endpointPermissions?.merchant_permissions?.can_edit_employee
  const canCreateEmployee = endpointPermissions?.merchant_permissions?.can_create_employee

  const role = permissions?.user_data?.role

  const bidBlocks = useSelector(state => state.app.settings.bidBlocks)


  const isAuto = bidBlocks?.auto?.display
  const isLight = personalAccountSettings?.show_documents_generation === false
  const isNomenclature = personalAccountSettings?.show_nomenclature_for_receipt === true

  return useRoutes([
    {
      path: '/',
      element: <RedirectWithQuery to={PATH_AFTER_LOGIN} />,
    },

    ...authRoutes,

    ...dashboardRoutes,

    ...sellersRoutes,

    ...companiesRoutes,

    ...docTemplatesRoutes,

    ...endpointsRoutes,

    // ...((canEditEndpoint || canCreateEndpoint) ? endpointsRoutes : []),
    // ...transportsRoutes,
    // ...(isAuto ? transportsRoutes : []),
    ...registersRoutes,
    // ...((isCreator || isApprover) ? registersRoutes : []),
    ...employeesRoutes,
    // ...((canEditEmployee || canCreateEmployee) ? employeesRoutes : []),

    ...reportDetailsRoutes,

    ...reportsRoutes,

    ...((isNomenclature || ( !isAuto && !isLight)) ? nomenclaturesRoutes : []),

    ...mainRoutes,

    // No match 404
    {path: '*', element: <RedirectWithQuery to="/operations" />},
  ]);
}
export default router
export {router}
